import { Controller } from "@hotwired/stimulus"

/**
 * Generic Modal Controller
 * 
 * Simple modal controller for dialog overlays. Supports:
 * - Click outside to close
 * - Escape key to close
 */
export default class extends Controller {
  static targets = ["container"]
  static values = {
    url: String
  }

  connect() {
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden'
    
    // Listen for escape key
    this.escapeHandler = this.closeOnEscape.bind(this)
    document.addEventListener('keydown', this.escapeHandler)
  }

  disconnect() {
    // Restore body scroll — but only when this was the LAST open modal.
    // With stacked modals, an unconditional reset unlocked scroll while
    // another modal was still open. (close() removes the element, which
    // fires this disconnect — single restore point.)
    if (!document.querySelector('[data-controller~="modal"]')) {
      document.body.style.overflow = ''
    }
    document.removeEventListener('keydown', this.escapeHandler)
  }

  close() {
    // Remove the modal element from DOM; disconnect() restores body scroll.
    this.element.remove()
  }

  closeOnBackdrop(event) {
    // Only close if clicking directly on the backdrop (this.element)
    if (event.target === this.element) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
